import { useContext } from "react"
import { useSelector } from "react-redux"

import History from "../../../history/History"
import { WorkQueueUpdateContext } from "../../../work_queues/pages/drawer/WorkQueueUpdateContext"

export default function HistoryDetails() {
    const ctx = useContext(WorkQueueUpdateContext)
    const activeCase = useSelector((state) => state.case.activeCase)

    const caseId = ctx?.caseId ?? activeCase?.case?.id ?? null

    return (
        <>
            <History caseIdFromDetails={caseId} />
        </>
    )
}